<svg class="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="1em" height="1em" aria-hidden="true" fill="currentColor"><path d="M8.006 1.078a.748.748 0 0 0-.477.172L3.64 4.36l-.002.002-.088.07h.012c-.344.32-.561.773-.561 1.28v8.538a.75.75 0 0 0 1.227.578L8 11.723l3.773 3.105A.75.75 0 0 0 13 14.25V5.711c0-.527-.234-1-.604-1.32h-.002l-.01-.008a1.76 1.76 0 0 0-.075-.062L8.482 1.25a.748.748 0 0 0-.476-.173Z"/></svg>

<style lang="scss">

  .icon {
    margin-right: 3px;

    color: #1d76db;
  }
</style>